import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Legend, Tooltip } from 'recharts';
import { getOrdersFromDaysStats } from "../../api";


export type _TstatsOrdersFromDays = {
    day: number
    ordersAmount: number
    revenue: number
}[]

export default function OrdersFromDays() {
    const [data, setData] = useState<any[]>([])
    const pDiv = useRef<HTMLDivElement>(null)

    useEffect(() => {
        getOrdersFromDaysStats().then((res) => {
            setData(res)
        })
    }, [])

    return (
        <div className="big-block-desktop">

            <div ref={pDiv} style={{ padding: '20px 0 20px 0', textAlign: 'center' }} className="major-header">Статистика по заказам</div>
            <LineChart
                width={(pDiv.current?.clientWidth) as number - 40}
                height={400}
                data={data}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis min={DD_MM(Date.now() - 1000 * 3600 * 24 * 30)} max={DD_MM(Date.now())} dataKey="day" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line name="Количество заказов" type="monotone" dataKey="ordersAmount" stroke="#c2332f" />
                <Line name="Выручка, $" type="monotone" dataKey="revenue" stroke="#82ca9d" />
            </LineChart>
        </div>
    )
}

function DD_MM(timestamp: number) {
    const date = new Date(timestamp);
    const yyyy = date.getFullYear();
    let mm = '' + date.getMonth() + 1; // Months start at 0!
    let dd = '' + date.getDate();

    if (+dd < 10) dd = '0' + dd;
    if (+mm < 10) mm = '0' + mm;

    const formattedToday = dd + '/' + mm + '/' + yyyy;

    return formattedToday
}